import React from 'react';
import CreatableSelect from 'react-select/creatable';
import TextDropDownPairFilter, {
  SelectOption,
  TextDropDownPairFilterProps,
  UnitComponentProps,
} from '../TextDropDownPairFilter/TextDropDownPairFilter';
import { StylesConfig } from 'react-select';

const CreatableDropdown = ({
  name,
  onChange,
  value,
  options,
}: UnitComponentProps) => {
  const styles: StylesConfig<SelectOption, false> = {
    container: (base) => ({
      ...base,
      height: ' 50px',
      width: '110px',
      border: '1px solid #dde5f7 !important',
      borderRadius: '0 0.25rem 0.25rem 0',
      borderLeft: '0',
    }),
    control: (base) => ({
      ...base,
      border: 'none',
      height: '48px',
      width: '108px',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      width: '0',
      margin: '0',
    }),
    clearIndicator: () => ({
      display: 'none',
    }),
  };

  const selectedValue = value
    ? options.find((e) => e.value === value) || { label: `${value}`, value }
    : null;
  return (
    <CreatableSelect
      options={options}
      onChange={(e) => onChange(e?.value)}
      styles={styles}
      aria-label={`${name}-unit`}
      placeholder=""
      value={selectedValue}
      backspaceRemovesValue
      isClearable
    />
  );
};

const TextCreateDropDownPairFilter = (props: TextDropDownPairFilterProps) => {
  return <TextDropDownPairFilter {...props} component={CreatableDropdown} />;
};

export default TextCreateDropDownPairFilter;
